import React from 'react';
import { Tooltip } from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import serverURL from '../config';

const CandidatesTable = ({ candidates, passThreshold = 23 }) => {
    const navigate = useNavigate();

    const handleRowClick = async (candidateId, candidateName) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${serverURL}/reports/results/${candidateId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = response.data;
            navigate(`/reports/${candidateId}`, { state: { data, candidateId: candidateId, candidateName: candidateName } });
        } catch (error) {
            console.error("Error fetching report data:", error);
        }
    };

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md">
                <thead className="bg-gray-800 text-black">
                    <tr className="bg-gray-200">
                        <th className="py-2 px-4 border-b text-center">Candidate ID</th>
                        <th className="py-2 px-4 border-b text-center">Employee ID</th>
                        <th className="py-2 px-4 border-b text-center">Name</th>
                        <th className="py-2 px-4 border-b text-center">Email</th>
                        <th className="py-2 px-4 border-b text-center">Total Correct</th>
                        <th className="py-2 px-4 border-b text-center">Total Attempted</th>
                        <th className="py-2 px-4 border-b text-center">Programming Points</th>
                        <th className="py-2 px-4 border-b text-center">Category 1</th>
                        <th className="py-2 px-4 border-b text-center">Answers 1</th>
                        <th className="py-2 px-4 border-b text-center">Total Attempted 1</th>
                        <th className="py-2 px-4 border-b text-center">Category 2</th>
                        <th className="py-2 px-4 border-b text-center">Correct Answers 2</th>
                        <th className="py-2 px-4 border-b text-center">Total Attempted 2</th>
                        <th className="py-2 px-4 border-b text-center">Category 3</th>
                        <th className="py-2 px-4 border-b text-center">Correct Answers 3</th>
                        <th className="py-2 px-4 border-b text-center">Total Attempted 3</th>
                        <th className="py-2 px-4 border-b text-center">Pass/ Fail</th>
                    </tr>
                </thead>
                <tbody>
                    {candidates.map((candidate, index) => {
                        // Extract category data
                        const categories = candidate.category_wise || [];
                        const categoryData = [
                            categories[0] || {},
                            categories[1] || {},
                            categories[2] || {}
                        ];

                        // Calculate percentage: (total_correct / total_attempted) * 100
                        const totalAttempted = Number(candidate.total_attempted) || 1; // Avoid division by zero
                        const totalCorrect = Number(candidate.total_correct);
                        const percentage = ((totalCorrect / totalAttempted) * 100).toFixed(2);
                        const isPassing = percentage >= 92;

                        return (
                            <tr
                                key={candidate.candidate_id}
                                className={`hover:bg-blue-100 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}
                                onClick={() => handleRowClick(candidate.candidate_id, candidate.candidate_name)}
                                style={{ cursor: 'pointer' }}
                            >
                                <td className="py-2 px-4 border-b">{candidate.candidate_id}</td>
                                <td className="py-2 px-4 border-b">{candidate.employee_id}</td>
                                <td className="py-2 px-4 border-b">{candidate.candidate_name}</td>
                                <td className="py-2 px-4 border-b">{candidate.candidate_email}</td>
                                <td className="py-2 px-4 border-b">{candidate.total_correct}</td>
                                <td className="py-2 px-4 border-b">{candidate.total_attempted}</td>
                                <td className="py-2 px-4 border-b">
                                    {candidate.programming_points}
                                    <span
                                        id={`tooltip-f-${candidate.candidate_id}`}
                                        className="cursor-pointer"
                                        style={{ marginLeft: "8px" }}
                                    >
                                        (f)
                                    </span>
                                    <span
                                        id={`tooltip-i-${candidate.candidate_id}`}
                                        className="cursor-pointer"
                                        style={{ marginLeft: "8px" }}
                                    >
                                        (i)
                                    </span>
                                    <Tooltip
                                        anchorId={`tooltip-f-${candidate.candidate_id}`}
                                        content={candidate.programming_feedback}
                                        place="top"
                                        style={{
                                            backgroundColor: "rgba(45, 55, 72, 100)",
                                            color: "#ffffff",
                                            borderRadius: "8px",
                                            padding: "16px",
                                            fontSize: "14px",
                                            minHeight: "100px",
                                            height: "auto",
                                            maxWidth: "300px",
                                            overflow: "visible",
                                        }}
                                    />
                                    <Tooltip
                                        anchorId={`tooltip-i-${candidate.candidate_id}`}
                                        content={candidate.submitted_code}
                                        place="top"
                                        style={{
                                            backgroundColor: "#2d3748",
                                            color: "#ffffff",
                                            borderRadius: "8px",
                                            padding: "16px",
                                            fontSize: "14px",
                                            minHeight: "100px",
                                            height: "auto",
                                            maxWidth: "300px",
                                            overflow: "visible",
                                        }}
                                    />
                                </td>



                                {categoryData.map((category, index) => (
                                    <React.Fragment key={index}>
                                        <td className="py-2 px-4 border-b">{category.category_name || ''}</td>
                                        <td className="py-2 px-4 border-b">{category.correct_answers || ''}</td>
                                        <td className="py-2 px-4 border-b">{category.total_attempted || ''}</td>
                                    </React.Fragment>
                                ))}

                                <td className='py-2 px-4 border-b'>
                                    <div className="flex flex-col">
                                        <span className="font-semibold">{percentage}%</span>
                                        <span className={isPassing ? 'text-green-600' : 'text-red-600'}>
                                            {isPassing ? 'Pass' : 'Fail'}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default CandidatesTable;
